import { useTranslate } from "@tolgee/react";
import React, { act } from "react";
import { Route, Routes } from "react-router-dom";
import { PageNotFound } from "../../commons/PageNotFound.js";
import { PageTopbarItem } from "../../commons/layout/PageSubmenu.js";
import { TaskIcon } from "../../features/tasks/TaskIcon.js";
import { TaskItem } from "./TaskItem.js";
import { TasksList } from "./TasksList.js";
import { getUrlSearchParamsByParamsName } from "../../commons/hooks/useStateWithUrlParams.js";

type PageSubmenuItem = PageTopbarItem;

export function TasksRoutes() {
  const { t } = useTranslate(["Global", "Tasks"]);

  const submenuItems: PageSubmenuItem[] = React.useMemo(() => {
    return [
      {
        name: "task-list",
        label: t("Tasks", { ns: "Tasks" }),
        icon: <TaskIcon />,
        path: {
          pathname: "/tasks",
          search: getUrlSearchParamsByParamsName(
            { status: ["OPEN"] },
            "filters"
          ).toString(),
        },
      },
    ];
  }, [t]);

  return (
    <Routes>
      <Route path="/" element={<TasksList submenuItems={submenuItems} />}>
        <Route path=":taskId" element={<TaskItem />} />
      </Route>

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
